import React, { FC } from 'react';
import styled from 'styled-components';
import LogoWithSlogan from './LogoWithSlogan';
import CitiesButton from 'Components/Header/CitiesButton';
import LinkWrapper from 'Components/Link/LinkWrapper';
import { URL } from 'constants/urlMaps';
import Text from 'Components/Typography/Text';
import ProfileButton from 'Components/Header/ProfileDropdown/ProfileButton';
import ThemeButton from 'Components/ThemedButton';
import { EnumButtonSize } from 'constants/enums';
import { colors } from 'constants/colors';
import { Box } from '@igooods/ui-kit';
import { Flex } from '@igooods/ui-kit';
import { hideBeforeLg, hideAfterLg, hideBeforeSm } from 'theme/helpers';
import { mediaSmDown, mediaLgDown } from 'theme/helpers/css';
import { shadows } from 'constants/shadows';
import BlockContainer from 'Components/landings/BlockContainer';
import SideMenu from '../SideMenu';
import ContactsModal from './ContactsModal';
import ExternalLink from 'Components/ExternalLink';
import useRootUrlWithSubdomain from 'utils/hooks/useRootUrlWithSubdomain';
import { useUpdCity } from 'utils/hooks/useUpdCity';
import { useSelector } from 'react-redux';
import { getCurrentShopId } from '../../../Modules/Shops/selectors';
import { getCurrentAddressName } from '../../../Modules/SearchAddress/selectors';
import { checkIsTempUser } from '../../../Modules/AAA/selectors';

export const LANDING_HEADER_SECTION_TEST_ID = 'LANDING_HEADER_SECTION_TEST_ID';
export const LANDING_NAV_LINKS_TEST_ID = 'LANDING_NAV_LINKS_TEST_ID';
export const LANDING_AUTH_BTN_TEST_ID = 'LANDING_AUTH_BTN_TEST_ID';

const StickySection = styled(BlockContainer).attrs({
  bgColor: colors.white,
  maxWidth: '1260px',
})`
  position: sticky;
  z-index: 10;
  top: 0;
  box-shadow: ${shadows.stickyHeader};
`;

const Container = styled(Flex).attrs({
  pt: { sm: 5, xs: 2 },
  pb: { sm: 6, xs: 2 },
  middle: true,
})`
  height: 50px;
  box-sizing: content-box;
`;

const LogoLink = styled(LinkWrapper)`
  flex-basis: 240px;
  flex-shrink: 0;
  margin-right: 20px;

  ${mediaSmDown`
    flex-basis: auto;
    margin-right: 8px;
  `}
`;

const Cities = styled(CitiesButton)`
  ${mediaSmDown`
    flex-basis: auto;
  `}
`;

const Nav = styled(Flex).attrs({ hideBefore: 'lg', grow: true, center: true })``;

export const ExternalNavLink = styled(ExternalLink)`
  margin-left: 16px;
`;

const Auth = styled(Box).attrs({ hideBefore: 'lg', ml: 3 })``;

const ContactsButton = styled(ContactsModal)`
  margin-left: 12px;

  ${mediaLgDown`
    margin-left: auto;
  `}

  ${hideBeforeSm}
`;

const CatalogButton = styled(LinkWrapper)`
  margin-left: 10px;

  ${hideBeforeLg}
`;

const BurgerBtn = styled(SideMenu)`
  margin-left: 8px;
  flex-shrink: 0;

  ${hideAfterLg};

  ${mediaSmDown`
    margin-left: auto;
  `}
`;

const Header: FC = () => {
  const { mainRoute } = useRootUrlWithSubdomain();
  const onCityChange = useUpdCity();
  const isTempUser = useSelector(checkIsTempUser);
  const currentShopId = useSelector(getCurrentShopId);
  const addressName = useSelector(getCurrentAddressName);

  return (
    <StickySection data-testid={LANDING_HEADER_SECTION_TEST_ID}>
      <Container>
        <LogoLink to={URL.root}>
          <LogoWithSlogan />
        </LogoLink>
        <Nav data-testid={LANDING_NAV_LINKS_TEST_ID}>
          <LinkWrapper to={URL.select_address}>
            <Text fontWeight="600">Список магазинов</Text>
          </LinkWrapper>
          <ExternalNavLink href={`${mainRoute}${URL.how_it_works}`}>
            <Text fontWeight="600">Как это работает</Text>
          </ExternalNavLink>
          <ExternalNavLink href={`${mainRoute}${URL.business}`}>
            <Text fontWeight="600">Доставка для бизнеса</Text>
          </ExternalNavLink>
        </Nav>
        <Cities onCityChange={onCityChange} checkCity />
        <Auth data-testid={LANDING_AUTH_BTN_TEST_ID}>
          {(isTempUser || (!isTempUser && currentShopId && addressName)) && <ProfileButton />}
        </Auth>
        <ContactsButton />
        <CatalogButton to={URL.select_address}>
          <ThemeButton size={EnumButtonSize.normal}>Заказать доставку</ThemeButton>
        </CatalogButton>
        <BurgerBtn />
      </Container>
    </StickySection>
  );
};

export default Header;
